import { useEffect, useState } from "react";
import QRCode from "react-qr-code";

export default function QrPage() {
    const [qrValue, setQrValue] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token") || "";
        const line = params.get("line") || "";
        const dynamicBlock = params.get("dynamicBlock") || "";

        let finalToken = token;

        // Special handling for mmmocl line
        if (line === "mmmocl") {
            finalToken = atob(token);
        }

        if (line === "bmrcl") {
            finalToken = dynamicBlock
                ? `${token}#${dynamicBlock}`
                : finalToken;
        }

        setQrValue(finalToken);

    }, []);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh" }}>
            <QRCode value={qrValue} />
        </div>
    );
}
